var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 5H1C0.45 5 0 5.45 0 6C0 6.55 0.45 7 1 7H17C17.55 7 18 6.55 18 6C18 5.45 17.55 5 17 5ZM1 12H11C11.55 12 12 11.55 12 11C12 10.45 11.55 10 11 10H1C0.45 10 0 10.45 0 11C0 11.55 0.45 12 1 12ZM17 0H1C0.45 0 0 0.45 0 1V1.01C0 1.56 0.45 2.01 1 2.01H17C17.55 2.01 18 1.56 18 1.01V1C18 0.45 17.55 0 17 0Z",
    fill: "#424167"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.03a3fb497ecdcfcbf029df2eb6f060c1.svg";
export { ForwardRef as ReactComponent };